/**
 * Side-effect module so mobile setup runs BEFORE the game wires up.
 *
 * ES imports are hoisted: a call placed in main.ts's body runs after every
 * import has already evaluated, so core-game would size the scratch canvas
 * against an un-expanded Telegram sheet. Import order is the only thing that
 * sequences module side effects, hence this file.
 */
import { initMobile } from "./mobile";
import { installAudioUnlock } from "./audio";

initMobile();

/* Armed before the player's first tap, whatever they happen to tap. */
installAudioUnlock();
